import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import OpenAppComp from '@ivy/fts/comps/OpenApp.vue';
import openApp from '@ivy/fts/openApp';
let GetMore = class GetMore extends Vue {
    constructor() {
        super(...arguments);
        this.id = `${Date.now()}${Math.random()}`;
    }
    async mounted() {
    }
    openApp() {
        openApp();
    }
    openAndroid() {
        let state = null;
        try {
            state = window.open("ivydadReadtool://weex/cyan-bean?id=3");
        }
        catch (e) { }
        if (state) {
            window.close();
        }
        else {
            window.location.href = "https://sj.qq.com/myapp/detail.htm?apkName=com.ivydad.readtool";
        }
    }
};
GetMore = tslib_1.__decorate([
    Component({ components: { OpenApp: OpenAppComp } })
], GetMore);
export default GetMore;
